/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
import React from 'react';
import {
    gql, useMutation, useQuery, useReactiveVar,
} from '@apollo/client';
import BILLING_MUTATION from 'app/graphql/network/billing';

import { isSubscription, SUBSCRIPTION_TYPES } from 'app/const/subscription';
import {
    subscriptionTypeVar, paymentMethodVar, selectedPeriodVar, promocodeVar, isGlobalLoadingVar,
} from 'app/apollo/reaction';
import { analyticService, errorService } from 'global/services';
import { GET_SUBSCRIPTION_TYPE } from 'app/graphql/client/subscription';
import { billingVarByMethodAndType, onCompletedBillingMutation } from 'app/containers/BasketResolver';
import { sleep } from 'global/utils';
import { BASKET_PAGE_ROOT_QUERY_INITIAL_COPY } from './accessors/useBasketData';


const BILLING_TOGGLE_SUBSCRIPTION_MUTATION = gql`
    mutation BILLING_TOGGLE_SUBSCRIPTION_MUTATION(
        $promocode: String,
        $period: String!,
        $payment_method: paymentMethod,
        $phone: String,
    ) {
        billing(
            promocode: $promocode,
            period: $period,
            payment_method: $payment_method,
            phone: $phone,
        ) {
            promocode
            payment_method
            isNewbie
            cart {
                period
                isSubscriptionActivated
                id
                type
            totals {
                ...ROOT_CART_TOTAL
            }
            discount_conditions {
                ...ROOT_CART_DISCOUNT_CONDITIONS
                }
            }
        }
    }
`;


// const BASKET_BILLING_QUERY = gql`
//     query REFETCH_BASKET_BILLING_QUERY(
//     $period: String!
// ) {
//     selectedPeriod @client @export(as: "period")

//     cart(
//         period: $period
//     ) {
//         period
//         isSubscriptionActivated
//         id
//         type
//         totals {
//             ...ROOT_CART_TOTAL
//         }
//         discount_conditions {
//             ...ROOT_CART_DISCOUNT_CONDITIONS
//         }
//     }
// }`;

export const useToggleSubscription = () => {
    const [mutateBilling] = useMutation(BILLING_TOGGLE_SUBSCRIPTION_MUTATION);
    const promocode = useReactiveVar(promocodeVar);

    const toggleSubscriptionHandler = async (type: string, method: string, promo: string) => {
        isGlobalLoadingVar(true);
        const next_payment_method = billingVarByMethodAndType(type, method);
        analyticService
            .push({
                eventName: 'Check_Subscription_Toggle',
                eventValue: isSubscription(type)
                    ? 'Check_Unselect_Subscription'
                    : 'Check_Select_Subscription',
            });
        try {
            await mutateBilling({
                variables: {
                    period: selectedPeriodVar(),
                    payment_method: next_payment_method,
                    promocode: promocode || promo,
                },
                onCompleted: (data) => {
                    onCompletedBillingMutation(data);
                },
                // update(cache, { data }) {
                //     // console.log(data);
                //     // // Записываем результат мутации прямо в кеш для запроса cart
                //     // cache.writeQuery({
                //     //     query: BASKET_PAGE_ROOT_QUERY_INITIAL_COPY,
                //     //     variables: { period: selectedPeriodVar() }, // те же переменные, что и в запросе
                //     //     data: { cart: data.billing.cart },
                //     // });
                // },
                // refetchQueries: () => {
                //     return [
                //         {
                //             query: BASKET_BILLING_QUERY,
                //             context: {
                //                 message: 'root:refetch:useToggleSubscription',
                //             },
                //         },
                //     ];
                // },
            });
            await sleep(400);
            isGlobalLoadingVar(false);
        } catch (e) {
            errorService.log({
                text: e?.text || 'Ошибка',
                source: 'server',
            });
            isGlobalLoadingVar(false);
        }
        return false;
    };

    return [toggleSubscriptionHandler];
};
